import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuienesSomosService {

  endpointApi = environment.apiCMSQuienes
  endpointApiRetalk = environment.apiCmsRetalk
  endpointApiCasos = environment.apiCmsCasos
  endpointApiTeam = environment.apiCmsTeam

  quienesContent: any;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getQuienesSomos() {
    this.quienesContent = this.http.get<any>(this.endpointApi + '/get?id=1')
      .pipe(
        map(resp => {
          return resp.data.who;
        }),
        catchError(this.handleError)
      )
    return this.quienesContent
  }
}
